var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nn-scroll-area',{attrs:{"nn-color":"royal-purple"}},[_c('canvas',{ref:"gear",staticClass:"animation-rotate",attrs:{"width":"400","height":"400"}},[_vm._v("no canvas")])])}
var staticRenderFns = []

export { render, staticRenderFns }